import * as React from 'react';
import type { SVGProps } from 'react';
const SvgSuccessFull2 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    aria-label="Success_full2"
    viewBox="0 0 24 24"
    {...props}
  >
    <circle
      cx={12}
      cy={12}
      r={9.6}
      fill="url(#Success_full2_svg__a)"
      opacity={0.25}
    />
    <path
      fill="url(#Success_full2_svg__b)"
      fillRule="evenodd"
      d="M17.197 8.073a.93.93 0 0 1 0 1.317l-6.35 6.35a1.3 1.3 0 0 1-1.829.008l-2.5-2.455a.932.932 0 0 1 1.307-1.33l2.1 2.064 5.954-5.954a.93.93 0 0 1 1.318 0"
      clipRule="evenodd"
    />
    <defs>
      <linearGradient
        id="Success_full2_svg__a"
        x1={18}
        x2={-6}
        y1={16.5}
        y2={16}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#62AB57" />
        <stop offset={1} stopColor="#C2E5BD" />
      </linearGradient>
      <linearGradient
        id="Success_full2_svg__b"
        x1={15.364}
        x2={1.331}
        y1={13.911}
        y2={13.516}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#62AB57" />
        <stop offset={1} stopColor="#C2E5BD" />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgSuccessFull2;
